import React from "react";
import InvoiceDetail from "./components/InvoiceDetail";

function InvoiceDetailModal(props: any) {
  return <InvoiceDetail {...props.extraInfo} />;
}

export default InvoiceDetailModal;
